import { Box } from '@mui/material';
import { DashboardMetricsSection } from 'modules';



export const DashboardActivity = () => {


  return (
    <Box
      display='flex'
      paddingBottom='1.5rem'
      columnGap='1rem'
      justifyContent='space-between'
      height='calc(100vh - 120px)'
    >
      {/* Dashboard Container */}



      {/* METRICROW */}
      <DashboardMetricsSection.FC />

      {/* SHERLOCK CHAT CONTEXT PANE */}
      {/* <ChatPane.FC /> */}
    </Box>

  );
};
